import { Box, Typography } from '@mui/material'
import { FC, ReactNode } from 'react'
import { border } from '../../layout/theme/border'
import { themeColor } from '../../layout/theme/color'
import { monoFontFamily } from '../../layout/theme/semanticTokens'

/** Label above value, for a properties side panel. */
export const Property: FC<{ label: ReactNode; children: ReactNode }> = ({ label, children }) => (
  <Box sx={{ 'py': 1.25, '&:first-of-type': { pt: 0 } }}>
    <Typography sx={{ fontSize: 12, fontWeight: 500, color: themeColor.slate50, mb: 0.5 }}>{label}</Typography>
    <Box sx={{
      fontSize: 13.5, color: themeColor.slate, display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap',
      minWidth: 0, overflowWrap: 'anywhere',
    }}>
      {children}
    </Box>
  </Box>
)

export const PropertyDivider: FC = () => (
  <Box role="separator" sx={{ borderTop: `${border.thin} solid ${border.light}`, my: 1.25 }} />
)

/** Muted secondary text (e.g. "—"); `mono` for hostnames and ids, `plain` keeps the normal text colour. */
export const Muted: FC<{ children: ReactNode; mono?: boolean; plain?: boolean }> = ({ children, mono, plain }) => (
  <Box
    component="span"
    sx={{ ...(plain ? {} : { color: themeColor.slate50 }), ...(mono ? { fontFamily: monoFontFamily, fontSize: 12.5 } : {}) }}
  >
    {children}
  </Box>
)
